module.exports = __webpack_public_path__ + "static/media/iconfinder_video_file_86884.a544b58a.png";